import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetInspectionCertificatesFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  config: Partial<HttpClientConfig>
}

export function getInspectionCertificatesFactory({
  repository,
}: GetInspectionCertificatesFactoryDependencies) {
  return async function getInspectionCertificates({ shipmentUUID, config }: Params) {
    try {
      return await repository.getInspectionCertificates(shipmentUUID, config)
    } catch (error) {
      throw new Error('Could not get inspection certificates', { cause: error as Error })
    }
  }
}

export function getInspectionCertificates({ shipmentUUID, config }: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newGetInspectionCertificates = getInspectionCertificatesFactory({
    repository,
  })
  return newGetInspectionCertificates({ shipmentUUID, config })
}
